/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConversationProviderDto
 */
export interface ConversationProviderDto {
    /**
     * Provider ID
     * @type {string}
     * @memberof ConversationProviderDto
     */
    id: string;
    /**
     * Provider first name
     * @type {string}
     * @memberof ConversationProviderDto
     */
    firstName: string;
    /**
     * Provider last name
     * @type {string}
     * @memberof ConversationProviderDto
     */
    lastName: string;
    /**
     * Provider practice name
     * @type {string}
     * @memberof ConversationProviderDto
     */
    practiceName?: string;
    /**
     * Provider photo URL
     * @type {string}
     * @memberof ConversationProviderDto
     */
    photoUrl?: string;
}

/**
 * Check if a given object implements the ConversationProviderDto interface.
 */
export function instanceOfConversationProviderDto(value: object): value is ConversationProviderDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    return true;
}

export function ConversationProviderDtoFromJSON(json: any): ConversationProviderDto {
    return ConversationProviderDtoFromJSONTyped(json, false);
}

export function ConversationProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationProviderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'practiceName': json['practiceName'] == null ? undefined : json['practiceName'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function ConversationProviderDtoToJSON(json: any): ConversationProviderDto {
    return ConversationProviderDtoToJSONTyped(json, false);
}

export function ConversationProviderDtoToJSONTyped(value?: ConversationProviderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'practiceName': value['practiceName'],
        'photoUrl': value['photoUrl'],
    };
}

